import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { UserServiceCreateResponseJson } from '@vmspdb/definitions';
import * as UserActions from './users.actions';

export const usersFeatureKey = 'users';

export interface UserState extends EntityState<UserServiceCreateResponseJson> {
  loading: boolean;
  total: number;
  // additional entities state properties
}

export const adapter: EntityAdapter<UserServiceCreateResponseJson> =
  createEntityAdapter<UserServiceCreateResponseJson>({
    selectId: (model) => model.uuid || '',
  });

export const initialState: UserState = adapter.getInitialState({
  // additional entity state properties
  total: 0,
  loading: true,
});

export const reducer = createReducer(
  initialState,
  on(UserActions.listUsers, (state) => ({
    ...state,
    loading: true,
  })),
  on(UserActions.listUsersFailure, (state, { error }) =>
    adapter.removeAll({ ...state, loading: false, error }),
  ),
  on(UserActions.addUser, (state, action) =>
    adapter.addOne(action.user, state),
  ),
  on(UserActions.upsertUser, (state, action) =>
    adapter.upsertOne(action.user, state),
  ),
  on(UserActions.addUsers, (state, action) =>
    adapter.addMany(action.users, state),
  ),
  on(UserActions.upsertUsers, (state, action) =>
    adapter.upsertMany(action.users, state),
  ),
  on(UserActions.updateUser, (state, action) =>
    adapter.updateOne(action.user, state),
  ),
  on(UserActions.updateUsers, (state, action) =>
    adapter.updateMany(action.users, state),
  ),
  on(UserActions.deleteUser, (state, action) =>
    adapter.removeOne(action.id, state),
  ),
  on(UserActions.deleteUsers, (state, action) =>
    adapter.removeMany(action.ids, state),
  ),
  on(UserActions.loadUsers, (state, action) =>
    adapter.setAll(action.users, state),
  ),
  on(UserActions.clearUsers, (state) => adapter.removeAll(state)),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const userSelectors = adapter.getSelectors();
